// extracted by mini-css-extract-plugin
export default {"checkmark":"circle-check_checkmark__wj9FL","circle":"circle-check_circle__A4pUe","stroke":"circle-check_stroke__3IlsT","check":"circle-check_check__sPlO4"};